<template>
  <a-tooltip v-if="hasHighlight">
    <template slot="title">
      <div v-for="message in highlight.messages" :key="message">{{ message }}</div>
    </template>
    <button
      type="button"
      class="time-value time-value--highlighted"
      :style="{ backgroundColor: highlight.color }"
      :data-testid="testId"
      @click="$emit('authorization', highlight.authorizationKeys[0])"
    >
      {{ value }}
    </button>
  </a-tooltip>
  <span v-else class="time-value" :data-testid="testId">{{ value }}</span>
</template>

<script>
import { Tooltip } from 'ant-design-vue'

export default {
  components: {
    'a-tooltip': Tooltip
  },
  props: {
    value: {
      type: String,
      default: '-'
    },
    highlight: {
      type: Object,
      default: () => ({})
    },
    testId: {
      type: String,
      default: undefined
    }
  },
  computed: {
    hasHighlight() {
      return Boolean(this.highlight?.authorizationKeys?.length)
    }
  }
}
</script>

<style scoped>
.time-value {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
}

.time-value--highlighted {
  padding: 1px 6px;
  border: 0;
  border-radius: var(--border-radius);
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.time-value--highlighted:focus-visible {
  outline: 2px solid #1890ff;
  outline-offset: 2px;
}
</style>
